import React, { useState } from 'react';
import cn from 'classnames';
import { Controller, useFormContext } from 'react-hook-form';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import SelectProject from '#component/form/multiple-select-project/index';
import { fetchSelectProjects, clearSelectProjects } from '#action/project/project-select';

export const ProjectField = props => {
  const { classes, defaultData, label, name = 'projectId' } = props;

  const dispatch = useDispatch();
  const [hasProject, setHasProject] = useState(defaultData ?? false);
  const { setValue, formState } = useFormContext() || {
    setValue: () => {},
    formState: {}
  };
  const { isSubmitted } = formState || {};
  const { projects, status } = useSelector(s => {
    const fetchedProjects = [...s.projectSelect.projects];
    if (s.user?.defaultProject) {
      if (!fetchedProjects.find(p => p.id === s.user.defaultProject.id)) {
        fetchedProjects.push(s.user.defaultProject);
      }
    }
    return { projects: fetchedProjects, status: s.status };
  }, shallowEqual);

  const handleProjectsFetch = e => dispatch(fetchSelectProjects(e.target.value));

  const clearProjects = () => {
    dispatch(clearSelectProjects());
  };

  const fetchProjects = () => {
    dispatch(fetchSelectProjects());
  };

  const projectToSelect = p => p?.map(i => ({
    label: `${i.title}`,
    value: i.id,
    ...i
  }));

  const handleChange = (e, onChange) => {
    const newProjectId = e?.value;
    setHasProject(true);
    onChange(newProjectId);
    setValue('project', e, { shouldDirty: true });
  };

  const projectsToSelect = projectToSelect(projects);

  return (
    <Controller
      name={name}
      render={({ field: { onChange, value, ...field }, fieldState: { error, isTouched } }) => (
        <SelectProject
          label={label}
          className={cn(classes.project, hasProject ? classes.mobilePlaceholder : null)}
          margin="normal"
          variant="outlined"
          data={projectsToSelect}
          setData={e => handleChange(e, onChange)}
          defaultData={defaultData}
          fetchProjects={handleProjectsFetch}
          clearProjects={clearProjects}
          loading={['loading'].includes(status)}
          textFieldOnFocus={fetchProjects}
          showDateRange={true}
          meta={{
            valid: !error,
            error: error?.message,
            touched: isTouched,
            submitFailed: isSubmitted
          }}
          {...field}
        />
      )}
    />
  );
};
